export const LOCAL_ENV: string = 'LOCAL_ENV';
export const DEMO_ENV: string = 'DEMO_ENV';
export const STAGING_ENV: string = 'STAGING_ENV';
export const PRODUCTION_ENV: string = 'PRODUCTION_ENV';

const ENV = env => ({
    production: PRODUCTION_ENV,
    staging: STAGING_ENV,
    demo: DEMO_ENV,
    local: LOCAL_ENV
})[env];

export const ENVIRONMENT = ENV(process.env.DEPLOY_ENV);
export const VERSION = '3.1.1';

export const IS_PRODUCTION = ENVIRONMENT === PRODUCTION_ENV;
